import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_499'),
        action: obj => {
          this.createDialog('SetAgentLevelDialog', {
            data: [obj],
            onManager: this.onManager,
            refresh: this.refresh,
            action: i18n.t('scope.text_499'),
          })
        },
      },
    ]
  },
}
